import * as React from "react";
import { Box } from "@mui/material";
import ReactQuill from "react-quill";

interface Props {
  question: any;
  onChange: (question: any) => void;
  setHasUnsavedChanges: (value: boolean) => void;
  readOnly: boolean;
}

const TextPartial: React.FC<Props> = ({
  question,
  onChange,
  setHasUnsavedChanges,
  readOnly,
}) => {
  const [staticNote, setStaticNote] = React.useState("");

  React.useEffect(() => {
    setStaticNote(question.static_note);
  });

  const handleChange = (text) => {
    setStaticNote(text);
    const updatedQuestion = {
      ...question,
      static_note: text,
    };
    onChange(updatedQuestion);
    setHasUnsavedChanges(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <ReactQuill
        theme="snow"
        className="field field-2 questionnaire-ql"
        value={staticNote}
        onChange={handleChange}
        modules={{
          clipboard: {
            matchVisual: false,
          },
        }}
        readOnly={readOnly}
      />
    </Box>
  );
};

export default TextPartial;
